import script from "./ComprarBoletos.vue?vue&type=script&setup=true&lang=js"
export * from "./ComprarBoletos.vue?vue&type=script&setup=true&lang=js"

import "./ComprarBoletos.vue?vue&type=style&index=0&id=8d4fe7e0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d4fe7e0"]])

export default __exports__